import { useTextScale } from "./useTextScale";

/** From this Android font size up, phone layouts sized for normal text overflow: weekday names, side-by-side figures. */
const ENLARGED_TEXT_SCALE = 1.5;

/** Whether Android's font size is large enough that a phone layout should switch to its roomier form. */
export const useIsTextEnlarged = (): boolean => useTextScale() >= ENLARGED_TEXT_SCALE;
